// extracted by mini-css-extract-plugin
module.exports = {"LayoutView":"LayoutView_LayoutView__24wku","shimmer":"LayoutView_shimmer__1E4Sy","empty":"LayoutView_empty__1BspU"};